
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import './LimitedEsignLetter.css';
import { Row, Col, Container } from '../../importCL';

interface ILimitedEsignLetterProps extends MappedComponentProperties {
    limitedEsignLetter?: string,
    printSectionLogo?: string,
}

export const LimitedEsignLetterEditConfig = {
    emptyLabel: 'Limited Esign Letter',
    isEmpty: (props: PropsWithChildren<ILimitedEsignLetterProps>) => {
        return !props || !props.limitedEsignLetter;
    },
};

const LimitedEsignLetter = (props: PropsWithChildren<ILimitedEsignLetterProps>): JSX.Element => {
    return (
        <Container id='limited-esign-letter' className='LimitedEsignLetter'>
            <Row>
                <Col>
                    {props.printSectionLogo &&
                        <Row className='LimitedEsignLetter__logoContainer print-only px-4 pt-10'>
                            <img loading='lazy' className='LimitedEsignLetter__printLogo' src={props.printSectionLogo} alt='Credit One Bank Logo' />
                            <hr className='LimitedEsignLetter__printRule' />
                        </Row>}
                    <Row className='LimitedEsignLetter__letterContainer'>
                        <span className='LimitedEsignLetter__printIcon no-print' role='button' tabIndex={0} aria-label='print this page'>
                            <svg className='LimitedEsignLetter__svg' data-prefix='fal'
                                data-icon='print' onClick={() => window.print()}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        window.print();
                                    }
                                }}
                                xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' data-fa-i2svg=''>
                                <path fill='currentColor'
                                    d='M432 192h-16v-82.75c0-8.49-3.37-16.62-9.37-22.63L329.37 9.37c-6-6-14.14-9.37-22.63-9.37H126.48C109.64 0 96 14.33 96 32v160H80c-44.18 0-80 35.82-80 80v96c0 8.84 7.16 16 16 16h80v112c0 8.84 7.16 16 16 16h288c8.84 0 16-7.16 16-16V384h80c8.84 0 16-7.16 16-16v-96c0-44.18-35.82-80-80-80zM320 45.25L370.75 96H320V45.25zM128.12 32H288v64c0 17.67 14.33 32 32 32h64v64H128.02l.1-160zM384 480H128v-96h256v96zm96-128H32v-80c0-26.47 21.53-48 48-48h352c26.47 0 48 21.53 48 48v80zm-80-88c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z'></path>
                            </svg>
                        </span>
                        {props.limitedEsignLetter ?
                            <Col className='LimitedEsignLetter__text'>
                                {transformHTMLParserLinks(props.limitedEsignLetter)}
                            </Col>
                            : <></>}
                    </Row>
                </Col>
            </Row>
        </Container>);
};

export default LimitedEsignLetter;
